import { Client } from "./Client.model";

export class CashLoan {
  id?: number;
  amount!: number;
  loanDate?: string;
  note?: string;
  isPaid: boolean = false;
  advancePayment: number = 0;
  client?: Client; // ✅ Add this
}
